module.exports = __webpack_public_path__ + "img/bonus_phone_usdt.6510b2ea.png";